import React, { useState } from 'react';
import { theme } from '../../../../shared/lib/styles';

const MatchPairsQuestion = ({ question, onAnswer, answered }) => {
    const [selectedLeft, setSelectedLeft] = useState(null);
    const [matched, setMatched] = useState(() => new Map());

    const isMatched = (side, index) => {
        for (const [l, r] of matched.entries()) {
            if (side === 'left' && l === index) return true;
            if (side === 'right' && r === index) return true;
        }
        return false;
    };

    const handleLeft = (i) => {
        if (answered || isMatched('left', i)) return;
        setSelectedLeft(i);
    };

    const handleRight = (j) => {
        if (answered || isMatched('right', j) || selectedLeft === null) return;
        const next = new Map(matched);
        next.set(selectedLeft, j);
        setSelectedLeft(null);
        setMatched(next);

        if (next.size === question.left.length) {
            const correct = question.pairs.every(([l, r]) => next.get(l) === r);
            onAnswer(correct);
        }
    };

    const pairColor = (side, index) => {
        if (!answered) {
            if (side === 'left' && selectedLeft === index) return theme.colors.tableHeaderBlue;
            return theme.colors.parchmentPaper;
        }
        for (const [l, r] of question.pairs) {
            if (side === 'left' && l === index) {
                const userR = matched.get(l);
                return userR === r ? 'rgba(200, 220, 190, 0.7)' : theme.colors.errorBg;
            }
            if (side === 'right' && r === index) {
                const userL = [...matched.entries()].find(([, rv]) => rv === index)?.[0];
                return userL === l ? 'rgba(200, 220, 190, 0.7)' : theme.colors.errorBg;
            }
        }
        return theme.colors.bgLight;
    };

    return (
        <div style={styles.grid}>
            <div style={styles.column}>
                {question.left.map((item, i) => (
                    <button
                        key={item}
                        type="button"
                        disabled={answered || isMatched('left', i)}
                        onClick={() => handleLeft(i)}
                        style={{
                            ...styles.item,
                            backgroundColor: pairColor('left', i),
                        }}
                    >
                        {item}
                    </button>
                ))}
            </div>
            <div style={styles.column}>
                {question.right.map((item, j) => (
                    <button
                        key={item}
                        type="button"
                        disabled={answered || isMatched('right', j)}
                        onClick={() => handleRight(j)}
                        style={{
                            ...styles.item,
                            backgroundColor: pairColor('right', j),
                        }}
                    >
                        {item}
                    </button>
                ))}
            </div>
        </div>
    );
};

const styles = {
    grid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: theme.spacing.lg,
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.sm,
    },
    item: {
        padding: theme.spacing.md,
        fontSize: theme.fontSize.base,
        borderRadius: theme.borderRadius.md,
        border: `1px solid ${theme.colors.borderMedium}`,
        cursor: 'pointer',
        textAlign: 'left',
    },
};

export default MatchPairsQuestion;
